export default __webpack_public_path__ + "static/media/002-tongue-depressor-red.54f78dae.svg";